import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import CornTortillaProduct from 'models/CornTortillaProduct'
import CornTortillaPackage from './CornTortillaPackage'
import BrandSpecificProductDesc from 'views/shared/BrandSpecificProductDesc'
import { brandNameOptions } from './constants'

const productOptions = {
  // eslint-disable-next-line react/display-name
  productDesc: () => (
    <BrandSpecificProductDesc initialBrandNameOptions={brandNameOptions} />
  ),
  packagingInfo: <CornTortillaPackage />,
  productTitle: 'Brand Specific Corn Tortillas (Soft)',
  model: CornTortillaProduct,
  validCategories: ['16'],
  validSubCategories: ['007'],
  brandSpecific: true,
}

const CornTortilla = () => <ProductForm product={productOptions} />

export default CornTortilla

export const getCornTortillaPackage = newProduct => {
  const newCornTortillaPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newCornTortillaPackage
}

export const updateCornTortillaPackage = newProduct => {
  const newCornTortillaPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newCornTortillaPackage
}
